import { useMemo } from 'react';
import { ProductCode } from '@contracts';
import useProductPrices from './useProductPrices';

const useProductPrice = (productCode: ProductCode | null | undefined): number | null => {
  const productCodes = useMemo(() => [productCode as ProductCode], [productCode]);
  const productPrices = useProductPrices(productCodes);

  return productCode ? productPrices[productCode as ProductCode] : null;
};

export default useProductPrice;
